import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Custom Link component that wraps react-router-dom's Link
 * Adds support for scrollTo prop which passes a target identifier via state
 * 
 * The scrollTo value is used by useScrollRestoration to scroll to an element
 * with a matching data-scroll-to attribute after navigation
 * 
 * @example
 * // Scroll to element with data-scroll-to="my-section" after navigation
 * <Link to="/page" scrollTo="my-section">Go to page</Link>
 * 
 * // On the target page:
 * <div data-scroll-to="my-section">Content</div>
 */
const Link = React.forwardRef(function Link({ scrollTo, state, to, children, ...props }, ref) {
    // Merge scrollTo into state if provided
    const mergedState = scrollTo 
        ? { ...state, scrollTo }
        : state;
    
    return (
        <RouterLink 
            ref={ref}
            to={to}
            state={mergedState}
            {...props}
        >
            {children}
        </RouterLink>
    );
});

Link.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    scrollTo: PropTypes.string,
    state: PropTypes.object,
    children: PropTypes.node,
};

Link.displayName = 'Link';

export default Link;
